// src/components/layout/Header.tsx
import React from "react";
import "../../css/Header.css";
import logo from "../../assets/qavach-logo.png";
import ProfileDrawer from "./ProfileDrawer";
import { useState } from "react";
import doctorAvatar from "../../assets/doctor-avatar.png";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const { doctor, logout, currentUser } = useAuth();
    
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleLogout = () => {
    logout(); // clears tokenStore + state
    navigate("/"); // go back to login
  };

  return (
    <header className="app-header">
      <div className="header-top">
        <img src={logo} alt="QAVACH Logo" className="logo" />

        {doctor && (
          <div className="doctor-profile">
            {/* <img src={doctorAvatar} alt="Doctor" className="doctor-avatar" /> */}

            <img
              src={doctorAvatar}
              alt="Doctor"
              className="doctor-avatar"
              style={{ cursor: "pointer" }}
              onClick={() => setIsDrawerOpen(true)}
            />

            {/* same look, just added Logout */}
            <span>
              Dr. {doctor.name}{" "}
              <span
                onClick={handleLogout}
                style={{
                  marginLeft: 12,
                  cursor: "pointer",
                  fontSize: 12,
                  fontWeight: 600,
                  textDecoration: "underline",
                }}
              >
              </span>
            </span>
          </div>
        )}
      </div>

      <div className="header-motto">
        <p>Fortifying Health, Prioritizing Prevention, Promoting Wellness</p>
      </div>
      <ProfileDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        // user={doctor}
        user={currentUser}
      />
    </header>
  );
};

export default Header;
